//V1 - do not changes
// import { Select, Spin } from "antd";
// import React, { useState } from "react";
// import Error from "../Error";
// import PlusButton from "../Buttons/plus";
// import { useNavigate } from "react-router-dom";
// import { select_search } from "../../Controllers/Global";
// import toast from "react-hot-toast";

// const Selectaddcomponent = React.forwardRef((props, focus) => {
//   const { index, ind, val, form, setForm, getFormdata } = props;

//   const [loader, setLoader] = useState(false);

//   let navigate = useNavigate();

//   const handleSelect = (e, index, ind) => {
//     let data = [...form];

//     data[index].options[ind].form.value = e;

//     if (data[index]?.options[ind]?.show?.check) {
//       data?.map((value, k) => {
//         value?.options?.map((val, i) => {
//           if (val?.show?.name == data[index].options[ind].form.name) {
//             data[k].options[i].show.status = e ? true : false;
//           }
//         });
//       });
//     }

//     setForm(data);
//     getFormdata(data);
//   };

//   const handleSearch = async (e, index, ind) => {
//     setLoader(true);

//     let data = [...form];
//     const normalize = (str) => {
//       return str
//         ?.toLowerCase()
//         .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // remove accents
//         .replace(/[^a-z0-9]/g, ""); // strip spaces & special chars
//     };

//     const select = !data[index].options[ind].form.api
//       ? { ...data[index].options[ind].form.params }
//       : {
//           api: data[index].options[ind].form.api,
//           search: normalize(e),
//           status: 1,
//         };

//     const search = await select_search(select);

//     if (search?.status) {
//       let options = [];

//       if (data[index].options[ind].form.name == "customer") {
//         search?.data?.data?.map((value, index) => {
//           options?.push({
//             value: value?._id,
//             label:
//               value?.name && value?.code && value?.phone
//                 ? value?.code + " " + value?.name + " (" + value?.phone + ")"
//                 : value?.name && value?.code
//                 ? value?.code + " " + value?.name
//                 : value?.phone && value?.code
//                 ? value?.code + " (" + value?.phone + ")"
//                 : value?.name && value?.phone
//                 ? value?.name + " (" + value?.phone + ")"
//                 : value?.name
//                 ? value?.name
//                 : value?.phone
//                 ? value?.phone
//                 : "",
//           });
//         });
//       } else {
//         search?.data?.data?.map((value, index) => {
//           options?.push({ value: value?._id, label: value?.name });
//         });
//       }

//       data[index].options[ind].form.options = options;

//       setForm(data);
//       getFormdata(data);
//       setLoader(false);
//     } else {
//       toast?.error(search?.message);
//       setLoader(false);
//     }
//   };

//   const handleOnKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//     }
//   };

//   return (
//     <React.Fragment>
//       <div className="flex w-full">
//         <div className="flex-grow w-full">
//           <Select
//             key={index}
//             id={index?.toString()?.concat(ind)}
//             name={val?.form?.name}
//             placeholder={val?.form?.placeholder}
//             className={
//               val?.form?.className
//                 ? val?.form?.className
//                 : "text-regular w-full"
//             }
//             ref={focus.current[val?.form?.name?.concat(index + "" + ind)]}
//             size={val?.form?.size}
//             mode={val?.form?.mode}
//             allowClear={val?.form?.allowClear}
//             showSearch={val?.form?.showSearch}
//             filterOption={val?.form?.filterOption}
//             // disabled={loader}
//             options={val?.form?.options}
//             value={val?.form?.value}
//             onKeyDown={handleOnKeyDown}
//             onClick={() => handleSearch("", index, ind)}
//             onFocus={() => handleSearch("", index, ind)}
//             onSearch={(e) => handleSearch(e, index, ind)}
//             onChange={(e) => handleSelect(e, index, ind)}
//           />
//         </div>
//         <div className="pl-3">
//           <PlusButton onClick={() => navigate(val?.path)} />
//         </div>
//       </div>
//       <Error id={val?.form?.name?.concat(index + "" + ind)} />
//     </React.Fragment>
//   );
// });

// export default Selectaddcomponent;


//v3 by faiyaz

import { Select, Spin } from "antd";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import Error from "../Error";
import PlusButton from "../Buttons/plus";
import { useNavigate }  from "react-router-dom";
import toast from "react-hot-toast";
import { select_search } from "../../Controllers/Global";
import debounce from "lodash.debounce";

const Selectaddcomponent = React.forwardRef((props, focus) => {
  const { index, ind, val, form, setForm, getFormdata } = props;

  const [loader, setLoader] = useState(false);
  const [options, setOptions] = useState(val?.form?.options || []);
  const navigate = useNavigate();

  // ----------------------------------------------------------------
  // 1. Normalize: only remove accents, KEEP SPACES
  // ----------------------------------------------------------------
  const normalize = useCallback((str) => {
    return str
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, ""); // removes accents only
  }, []);

  // ----------------------------------------------------------------
  // 2. Load via loadOptions (new way) OR api + select_search (legacy)
  // ----------------------------------------------------------------
  const loadOptions = useCallback(
    async (search = "") => {
      const normalizedSearch = normalize(search);

      // NEW: use loadOptions if provided
      if (val?.form?.loadOptions) {
        try {
          const opts = await val.form.loadOptions(normalizedSearch);
          return opts || [];
        } catch (err) {
          toast.error("Failed to load options");
          return [];
        }
      }

      // LEGACY: fallback to api + select_search
      if (val?.form?.api) {
        try {
          const payload = {
            api: val.form.api,
            search: normalizedSearch,
            status: 1,
          };
          const res = await select_search(payload);
          if (res?.status) {
            // Handle customer special label
            if (val?.form?.name === "customer") {
              return res.data.data.map((c) => ({
                value: c._id,
                label:
                  c?.name && c?.code && c?.phone
                    ? `${c.code} ${c.name} (${c.phone})`
                    : c?.name && c?.code
                    ? `${c.code} ${c.name}`
                    : c?.phone && c?.code
                    ? `${c.code} (${c.phone})`
                    : c?.name && c?.phone
                    ? `${c.name} (${c.phone})`
                    : c?.name || c?.phone || "",
              }));
            }
            // Default: name only
            return res.data.data.map((item) => ({
              value: item._id,
              label: item.name,
            }));
          }
        } catch (err) {
          toast.error("Search failed");
        }
        return [];
      }

      return [];
    },
    [val?.form?.loadOptions, val?.form?.api, val?.form?.name, normalize]
  );

  // ----------------------------------------------------------------
  // 3. Debounced search (400ms)
  // ----------------------------------------------------------------
  const debouncedLoad = useMemo(
    () =>
      debounce((search) => {
        setLoader(true);
        loadOptions(search).then((opts) => {
          setOptions(opts);
          setLoader(false);
        });
      }, 400),
    [loadOptions]
  );

  // ----------------------------------------------------------------
  // 4. Initial load on mount
  // ----------------------------------------------------------------
  useEffect(() => {
    debouncedLoad("");
    return () => debouncedLoad.cancel();
  }, [debouncedLoad]);

  // ----------------------------------------------------------------
  // 5. Search handler
  // ----------------------------------------------------------------
  const handleSearch = (value) => {
    debouncedLoad(value);
  };

  // ----------------------------------------------------------------
  // 6. Select handler (unchanged logic)
  // ----------------------------------------------------------------
  const handleSelect = (e) => {
    const data = [...form];
    data[index].options[ind].form.value = e;

    // Show/hide logic
    if (data[index]?.options[ind]?.show?.check) {
      data.forEach((section, k) => {
        section.options.forEach((opt, i) => {
          if (opt?.show?.name === data[index].options[ind].form.name) {
            data[k].options[i].show.status = !!e;
          }
        });
      });
    }

    setForm(data);
    getFormdata(data);
  };

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  return (
    <div className="flex w-full">
      <div className="flex-grow w-full">
        <Select
          key={`${index}-${ind}`}
          id={`${index}-${ind}`}
          placeholder={val?.form?.placeholder}
          className={val?.form?.className || "text-regular w-full"}
          ref={focus.current?.[val?.form?.name + index + ind]}
          size={val?.form?.size}
          mode={val?.form?.mode}
          allowClear={val?.form?.allowClear}
          showSearch={val?.form?.showSearch}
          filterOption={val?.form?.filterOption}
          loading={loader}
          options={options}
          value={val?.form?.value}
          onKeyDown={handleOnKeyDown}
          onSearch={handleSearch}
          onChange={handleSelect}
          notFoundContent={loader ? <Spin size="small" /> : "No results"}
        />
      </div>

      <div className="pl-3">
        <PlusButton onClick={() => navigate(val?.path)} />
      </div>

      <Error id={val?.form?.name + index + ind} />
    </div>
  );
});

export default Selectaddcomponent;